import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Matches scripts/uploadPractices.js — override with REACT_APP_* in .env.local if needed.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDUAb9aD6J5zha5dp7cl52B7BjZOgkciN0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "alliedoms-qi.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "alliedoms-qi",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "alliedoms-qi.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "900443677952",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:900443677952:web:f77745c10be992ce2a3fe5",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
